var module = angular.module('octopusApp.infrastructure');

module.directive("octoPlaceholder", function(octoUtil, $compile, $rootScope) {
    return {
        restrict: 'AC',
        link: function(scope, element, attr) {
            var sectionName = "section" + attr.octoPlaceholder;
            var placeholder = element[0];


            $rootScope[sectionName] = placeholder;

            var watchEvent = $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams, options) {
                element.html('');
            });

            scope.$on('$destroy', function() {
                delete $rootScope[sectionName];
                watchEvent();
            });





            /* $rootScope["section" + attr.octoPlaceholder] = element[0];
             console.log("Placeholder: Adding - "  + attr.octoPlaceholder);


             var watchEvent = $rootScope.$on('$stateChangeStart',function(e, a, b) {
                  // Clear on navigate
                 console.log("Placeholder: Clearing- "  + attr.octoPlaceholder);
                  element.html('');
              });

             scope.$on('$destroy', function() {
                 //stop watching when scope is destroyed
                 console.log("Placeholder: Detatching- "+ attr.octoPlaceholder);
                 delete $rootScope["section" + attr.octoPlaceholder];
                 watchEvent();
             });*/
        }
    };
});




//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/octo_placeholder.js
// module id = 3693671187268991
// module chunks = 1